import Divider from '@/components/divider/Divider'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import React from 'react'

const Links: React.FC = () => {
  return (
    <Grid
      container
      direction="column"
      columnSpacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      marginBottom="50px"
    >
      <Grid size={10}>
        <h1>Länkar och sponsorer</h1>
      </Grid>

      <Grid
        size={11}
        spacing={2}
        container
        direction="row"
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <h2>Vi finns på olika sociala medier</h2>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link
              href="https://www.instagram.com/scoutmusikkaren/"
              style={{ display: 'flex' }}
            >
              Instagram <InstagramIcon />
            </Link>
          </b>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link
              href="https://www.facebook.com/scoutmusikkaren/"
              style={{ display: 'flex' }}
            >
              Facebook <FacebookIcon />
            </Link>
          </b>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link
              href="https://www.youtube.com/@KarlshamnsScoutmusikk%C3%A5r"
              style={{ display: 'flex' }}
            >
              YouTube <YouTubeIcon />
            </Link>
          </b>
        </Grid>
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid
        size={11}
        container
        spacing={2}
        direction="row"
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={12}>
          <h2>Förbund</h2>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link
              href="https://www.scouterna.se/hitta-scoutkar/blekinge-lan/karlshamns-kommun/karlshamns-sjoscoutkar/"
              style={{ display: 'flex' }}
            >
              Karlshamns Sjöscoutkår
            </Link>
          </b>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link href="https://www.scouterna.se/" style={{ display: 'flex' }}>
              Scoutförbundet
            </Link>
          </b>
        </Grid>
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid
        size={11}
        container
        spacing={2}
        direction="row"
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={12}>
          <h2>Sponsorer</h2>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link href="https://www.karlshamn.se/" style={{ display: 'flex' }}>
              Karlshamns Kommun
            </Link>
          </b>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link
              href="https://www.sparbankenikarlshamn.se/"
              style={{ display: 'flex' }}
            >
              Sparbanken i Karlshamn
            </Link>
          </b>
        </Grid>
      </Grid>

      <Divider size={{ xs: 11, md: 8 }} />

      <Grid
        size={11}
        container
        spacing={2}
        direction="row"
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={12}>
          <h2>Extra Tack</h2>
        </Grid>
        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link
              href="https://www.karlshamn.se/forskola-och-skola/musikskola/musikskolan/"
              style={{ display: 'flex' }}
            >
              Karlshamns Musikskola
            </Link>
          </b>
        </Grid>

        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link
              href="https://karlshamnsmusikkar.se/"
              style={{ display: 'flex' }}
            >
              Karlshamns Musikkår
            </Link>
          </b>
        </Grid>

        <Grid size={12} display="flex" justifyContent="center">
          <b>
            <Link href="https://www.trumpeter.se/" style={{ display: 'flex' }}>
              TrumPeter
            </Link>
          </b>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Links
